<template>
  <div class="ol-actions-panel ol-actions-email" role="tabpanel">
    <div id="replyEm"></div>
    <LoadingSpinner v-if="startLoadingSendEmail" />

    <template v-if="!startLoadingSendEmail">
      <div
        v-if="selectedContact"
        class="ol-actions-banner ol-actions-banner--info"
      >
        <i class="icon-info ol-actions-banner__icon" aria-hidden="true"></i>
        <p class="ol-actions-banner__text mb-0">
          {{
            $t("lang.opportunities.email_direct_banner", {
              name: selectedContact.name,
            })
          }}
        </p>
      </div>

      <div class="ol-actions-email-fields">
        <div class="ol-actions-email-fields__row ol-actions-email-fields__row--muted">
          <span class="ol-actions-email-fields__label">{{
            $t("lang.opportunities.field_from")
          }}</span>
          <span class="ol-actions-email-fields__value">{{
            reply_email.email_selected.response_to || "—"
          }}</span>
        </div>

        <div class="ol-actions-email-fields__row">
          <span class="ol-actions-email-fields__label">{{
            $t("lang.opportunities.field_to")
          }}</span>
          <div ref="emailTo" class="ol-actions-email-to">
            <div
              v-if="selectedContact"
              class="ol-actions-chip"
              @click.stop="toggleList"
            >
              <span class="ol-actions-chip__avatar">{{
                getPersonInitials(selectedContact.name)
              }}</span>
              <span class="ol-actions-chip__name">{{ selectedContact.name }}</span>
              <span class="ol-actions-chip__email"
                >&lt;{{ selectedContact.email }}&gt;</span
              >
            </div>
            <button
              v-else
              type="button"
              class="ol-actions-chip ol-actions-chip--placeholder"
              @click.stop="toggleList"
            >
              {{ $t("lang.opportunities.field_to") }}
            </button>
            <div v-if="showList" class="ol-actions-email-dropdown" @click.stop>
              <button
                v-for="(b, key) in contactOptions"
                :key="b.id != null ? b.id : key"
                type="button"
                class="ol-actions-email-dropdown__item"
                :class="{
                  'ol-actions-email-dropdown__item--active': isSelected(b),
                }"
                @click.stop="selectTo(b)"
              >
                <span class="ol-actions-email-dropdown__name">{{
                  b.name || b.email
                }}</span>
                <span class="ol-actions-email-dropdown__mail">{{
                  b.email
                }}</span>
              </button>
              <div
                v-if="!contactOptions.length"
                class="ol-actions-email-dropdown__empty"
              >
                —
              </div>
            </div>
          </div>
        </div>

        <div class="ol-actions-email-fields__row">
          <span class="ol-actions-email-fields__label">{{
            $t("lang.opportunities.field_subject")
          }}</span>
          <input
            id="input_subject"
            v-model="reply_email.subject"
            type="text"
            class="ol-actions-email-fields__input"
            :placeholder="$t('lang.opportunities.subject_placeholder')"
          />
        </div>
      </div>

      <div class="ol-actions-email-editor">
        <ckeditor
          :editor="editorInitial"
          v-model="editorData"
          :config="editorConfig"
        />
      </div>

      <div
        class="ol-actions-dropzone"
        :class="{ 'ol-actions-dropzone--active': isDragging }"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop"
        @click="triggerFileInput"
      >
        <input
          ref="fileInput"
          type="file"
          class="ol-actions-dropzone__input"
          @change="selectFile"
        />
        <div class="ol-actions-dropzone__left">
          <div class="ol-actions-dropzone__icon-wrap">
            <i class="icon-paperclip" aria-hidden="true"></i>
          </div>
          <div>
            <div class="ol-actions-dropzone__title">
              {{ $t("lang.opportunities.attach_document") }}
            </div>
            <div class="ol-actions-dropzone__hint">
              {{ $t("lang.opportunities.attach_drag_hint") }}
            </div>
            <div v-if="file" class="ol-actions-dropzone__file">
              {{ file.name }}
            </div>
          </div>
        </div>
        <button
          type="button"
          class="ol-actions-btn ol-actions-btn--outline"
          @click.stop="triggerFileInput"
        >
          {{ $t("lang.opportunities.browse") }}
        </button>
      </div>

      <div v-if="errors.length" class="alert alert-danger w-100 mt-2">
        <ul class="mb-0">
          <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
        </ul>
      </div>

      <div class="ol-actions-panel__footer ol-actions-panel__footer--between">
        <div class="ol-actions-panel__footer-left">
          <button
            type="button"
            class="ol-actions-btn ol-actions-btn--outline"
            @click="cleanFields"
          >
            {{ $t("lang.label.clean") }}
          </button>
          <div class="dropdown dropup d-inline-block ml-2">
            <button
              ref="templateDropdownToggle"
              type="button"
              class="ol-actions-btn ol-actions-btn--outline dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :disabled="startLoadingSendEmail"
              @click="getTemplateList"
            >
              {{ $t("lang.emailsettings.templates") }}
            </button>
            <div class="dropdown-menu ol-actions-templates-dropdown">
              <a
                v-for="(template, key) in templateList"
                :key="key"
                class="dropdown-item c-pointer hover-bg token"
                @click="addTemplete(template.id)"
              >
                {{ template.title }}
              </a>
            </div>
          </div>
        </div>

        <div v-if="activateSpark == '0'" class="ol-actions-panel__footer-right">
          <Tooltip :text="$t('lang.notification.prospecting_no_exist')">
            <button
              type="button"
              class="ol-actions-btn ol-actions-btn--primary"
              disabled
            >
              {{ $t("lang.opportunities.send_email_cta") }}
            </button>
          </Tooltip>
        </div>
        <div v-else class="ol-actions-panel__footer-right">
          <button
            type="button"
            class="ol-actions-btn ol-actions-btn--primary"
            @click="sendEmail"
          >
            {{ $t("lang.opportunities.send_email_cta") }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { emailsService } from "@/_services";
import $ from "jquery";
import { mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  data() {
    return {
      errors: [],
      reply_email: {
        to: "",
        subject: "",
        message: "",
        email_selected: {
          id: null,
          link_id: this.linkId,
          response_to: null,
        },
      },
      file: null,
      loadingTemplates: false,
      startLoadingSendEmail: false,
      showList: false,
      selectedContact: null,
      isDragging: false,
      editorInitial: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: ["heading", "|", "bold", "italic", "|", "link"],
      },
    };
  },

  props: {
    linkId: String,
    campaignId: String,
    businessContacts: Array,
    activateSpark: String,
    emailSelected: String,
    labelFromSelected: String,
  },

  watch: {
    editorData() {
      this.reply_email.message = this.$sanitize(this.editorData);
    },
    businessContacts: {
      immediate: true,
      handler(contacts) {
        if (contacts && contacts.length && !this.selectedContact) {
          this.initDefaultContact();
        }
      },
    },
  },

  components: {
    LoadingSpinner,
    ckeditor: CKEditor.component,
    Tooltip,
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    contactOptions() {
      return Array.isArray(this.businessContacts) ? this.businessContacts : [];
    },
    templateList() {
      if (!this.linkId) {
        return [];
      }
      const list = this.$store.getters["emails/templatesForLink"](this.linkId);
      return list !== undefined ? list : [];
    },
  },

  created() {
    this.reply_email.email_selected.response_to = this.emailSelected;
    this.reply_email.label_from = this.labelFromSelected;
    this.initDefaultContact();
  },

  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },

  methods: {
    ...mapActions("opportunities", {
      reloadOpportunity: "reloadOpportunity",
    }),

    getPersonInitials(name) {
      if (!name || typeof name !== "string") {
        return "?";
      }
      const trimmed = name.trim();
      if (!trimmed || trimmed.indexOf("@") !== -1) {
        return "?";
      }
      return trimmed
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0))
        .join("")
        .substring(0, 2)
        .toUpperCase();
    },

    isSelected(b) {
      // Se compara por id y no por identidad de objeto: al recargar la
      // oportunidad el array llega con objetos nuevos.
      return !!this.selectedContact && this.selectedContact.id === b.id;
    },

    initDefaultContact() {
      // Solo se preselecciona un contacto que realmente tenga email:
      // si no, el "À" queda con un destinatario que nunca se puede enviar.
      const withEmail = this.contactOptions.filter((c) => c && c.email);
      if (withEmail.length) {
        this.selectTo(withEmail[0]);
      }
    },

    handleDocumentClick(e) {
      const toEl = this.$refs.emailTo;
      if (toEl && !toEl.contains(e.target)) {
        this.showList = false;
      }
    },

    toggleList() {
      this.showList = !this.showList;
    },

    addTemplete(id) {
      this.getTemplate(id);
    },

    getTemplate(id) {
      this.loadingCurrent = true;
      emailsService
        .getTemplate(id)
        .then((result) => {
          this.editorData = result.message;
        })
        .catch(() => {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.loadingCurrent = false;
        });
    },

    validEmail(email) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(email);
    },

    selectTo(b) {
      this.selectedContact = b;
      this.reply_email.to = b.email;
      this.reply_email.business_contact_id = b.id;
      this.showList = false;
    },

    selectFile(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
    },

    triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },

    onDragOver() {
      this.isDragging = true;
    },

    onDragLeave() {
      this.isDragging = false;
    },

    onDrop(e) {
      this.isDragging = false;
      this.selectFile(e);
    },

    checkForm() {
      this.errors = [];
      if (!this.reply_email.to) {
        this.errors.push("Email is required.");
      }
      if (!this.reply_email.message) {
        this.errors.push("The message field can not be blank.");
        return false;
      }
      if (this.reply_email.message.length < 3) {
        this.errors.push("Enter at least three letters in the message field.");
        return false;
      }

      if (!this.errors.length) {
        return true;
      }
    },

    cleanFields() {
      this.reply_email.subject = "";
      this.reply_email.message = "";
      this.reply_email.label_from = this.labelFromSelected;
      this.reply_email.email_selected.response_to = this.emailSelected;
      this.editorData = "";
      this.file = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
      this.initDefaultContact();
    },

    sendEmail() {
      if (this.checkForm()) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.sendemail"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.send"),
        }).then((result) => {
          if (result.value) {
            this.startLoadingSendEmail = true;
            if (
              !this.reply_email.to.includes("*") &&
              !this.reply_email.to.includes("(")
            ) {
              delete this.reply_email["business_contact_id"];
              if (!this.validEmail(this.reply_email.to)) {
                this.errors.push("The email field is invalid.");
                this.startLoadingSendEmail = false;
                return false;
              }
            }
            emailsService
              .replyEmail(this.reply_email, this.file)
              .then(() => {
                let date_ob = new Date();
                let date = ("0" + date_ob.getDate()).slice(-2);
                let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
                let year = date_ob.getFullYear();

                var newEmail = {
                  id: "newEmail",
                  name: this.reply_email.label_from,
                  link: this.reply_email.subject,
                  comment: this.reply_email.message,
                  type: "emailsentopportunity",
                  response_from: this.reply_email.to,
                  creation_date: year + "-" + month + "-" + date,
                };
                this.$emit("addEmail", newEmail);

                if (this.$route.name === "opportunities") {
                  this.startLoadingSendEmail = false;
                } else {
                  this.startLoadingSendEmail = false;
                  this.cleanFields();
                }
              })
              .catch((error) => {
                this.startLoadingSendEmail = false;
                this.$swal({
                  type: "error",
                  title: this.$t("lang.label.error"),
                  text:
                    error && error.error
                      ? error.error
                      : this.$t("lang.label.error"),
                  showConfirmButton: true,
                });
              });
          }
        });
      }
    },

    getTemplateList() {
      if (this.loadingTemplates) {
        return;
      }
      if (this.$store.getters["emails/hasTemplatesForLink"](this.linkId)) {
        return;
      }
      this.loadingTemplates = true;
      this.$store
        .dispatch("emails/ensureEmailTemplates", { linkId: this.linkId })
        .finally(() => {
          this.loadingTemplates = false;
          this.$nextTick(() => {
            const el = this.$refs.templateDropdownToggle;
            if (el) {
              $(el).dropdown("show");
            }
          });
        });
    },
  },
};
</script>

<style scoped>
.ol-actions-panel {
  padding: 1rem 1.25rem;
}

.ol-actions-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 14px;
}

.ol-actions-banner--info {
  background: #f7f7fe;
  border: 1px solid #eeeefc;
}

.ol-actions-banner__icon {
  color: #4b4be1;
  font-size: 16px;
  margin-top: 1px;
  flex-shrink: 0;
}

.ol-actions-banner__text {
  font-size: 12px;
  color: #3c3489;
  line-height: 1.5;
}

.ol-actions-email-fields {
  display: flex;
  flex-direction: column;
  gap: 1px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: visible;
  margin-bottom: 10px;
}

.ol-actions-email-fields__row {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: white;
  border-top: 1px solid #f4f4f7;
  min-height: 44px;
}

.ol-actions-email-fields__row:first-child {
  border-top: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ol-actions-email-fields__row:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.ol-actions-email-fields__row--muted {
  background: #fafafb;
}

.ol-actions-email-fields__label {
  width: 60px;
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.ol-actions-email-fields__value {
  flex: 1;
  font-size: 13px;
  color: #111827;
  word-break: break-word;
}

.ol-actions-email-fields__input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #111827;
  font-family: inherit;
  padding: 0;
  min-width: 0;
}

.ol-actions-email-to {
  flex: 1;
  position: relative;
  min-width: 0;
}

.ol-actions-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eeeefc;
  padding: 3px 8px 3px 4px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  max-width: 100%;
}

.ol-actions-chip--placeholder {
  color: #6b7280;
  font-size: 12px;
}

.ol-actions-chip__avatar {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #4b4be1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 500;
  flex-shrink: 0;
}

.ol-actions-chip__name {
  font-size: 12px;
  font-weight: 500;
  color: #3c3489;
}

.ol-actions-chip__email {
  font-size: 11px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ol-actions-email-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 4px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 0;
}

.ol-actions-email-dropdown__empty {
  padding: 8px 12px;
  font-size: 12px;
  color: #6b7280;
}

.ol-actions-email-dropdown__item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 7px 12px;
  border: none;
  background: white;
  font-size: 13px;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
}

.ol-actions-email-dropdown__item:hover {
  background: #f4f4f7;
}

.ol-actions-email-dropdown__item--active {
  background: #f7f7fe;
}

.ol-actions-email-dropdown__name {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #111827;
  line-height: 1.3;
}

.ol-actions-email-dropdown__mail {
  display: block;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.3;
}

.ol-actions-email-editor {
  margin-top: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.ol-actions-email-editor >>> .ck-editor__editable {
  min-height: 140px;
}

.ol-actions-dropzone {
  margin-top: 10px;
  border: 1.5px dashed #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafafb;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.ol-actions-dropzone--active {
  border-color: #4b4be1;
  background: #f7f7fe;
}

.ol-actions-dropzone__input {
  display: none;
}

.ol-actions-dropzone__left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.ol-actions-dropzone__icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #eeeefc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b4be1;
  flex-shrink: 0;
}

.ol-actions-dropzone__title {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
}

.ol-actions-dropzone__hint {
  font-size: 11px;
  color: #6b7280;
  margin-top: 1px;
}

.ol-actions-dropzone__file {
  font-size: 11px;
  color: #4b4be1;
  margin-top: 4px;
}

.ol-actions-panel__footer {
  display: flex;
  align-items: center;
  margin-top: 14px;
}

.ol-actions-panel__footer--between {
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.ol-actions-panel__footer-left,
.ol-actions-panel__footer-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.ol-actions-btn {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 14px;
  line-height: 1.2;
}

.ol-actions-btn--primary {
  background: #4b4be1;
  color: white;
  border: none;
}

.ol-actions-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ol-actions-btn--outline {
  background: white;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.ol-actions-panel__footer-left >>> .ol-actions-templates-dropdown {
  max-height: 220px;
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 16rem;
  max-width: 22rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.ol-actions-panel__footer-left >>> .ol-actions-templates-dropdown .dropdown-item {
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
  padding: 0.4rem 0.75rem;
}
</style>
